import React from 'react';
import classNames from 'classnames';
import Icon from '../../Icon/Icon';
import checkIcon from '../../../images/echeck.svg';

class Checkbox extends React.Component {
    render() {
        const { className, checked, onChange, children, ...rest } = this.props;

        return (
            <label className={classNames('checkbox', className, { checked })}>
                <input type='checkbox' checked={checked} onChange={onChange} {...rest} />
                <div className='checkbox__check'>
                    <Icon glyph={checkIcon} />
                </div>
                <span className='checkbox__text'>{children}</span>
            </label>
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./components/Form/Checkbox/Checkbox.jsx